import React from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

import RoutesHelper from 'helpers/RoutesHelper'

import { Button, Text } from 'components/base'
import notFoundImage from 'assets/images/not-found.svg'
import MetaSupport from 'screens/Metabar/Support'
import { getFirstChannelId } from 'data/channels/selectors'

export const DefaultButton = () => {
  const firstChannelId = useSelector(getFirstChannelId)
  return (
    <Button.Primary
      href={
        firstChannelId
          ? RoutesHelper.noteChannelIndex({ channelId: firstChannelId })
          : RoutesHelper.home()
      }
    >
      Back to my docs
    </Button.Primary>
  )
}

const defaultImg = (
  <img src={notFoundImage} alt="not-found" style={{ width: 564 }} />
)

const ErrorWrapper = ({
  subtitle,
  title,
  image = defaultImg,
  children,
  goBackButton = <DefaultButton />,
  noBackground,
  metaSupportDisplay = true,
}) => (
  <div
    className={classNames(
      'l-main-body flexbox flexbox-centered flexbox-grow font-size-normal',
      { 'background-shade-100': !noBackground }
    )}
  >
    <div className="flexbox flexbox-column flexbox-align-center flexbox-centered">
      <div className="flexbox flexbox-centered margin-bottom-larger">
        {image}
      </div>
      <Text.Subtitle className="margin-bottom-medium">{title}</Text.Subtitle>
      {subtitle && (
        <div className="font-weight-medium shade-10 margin-bottom-larger">
          {subtitle}
        </div>
      )}
      {children && (
        <div className="center-text shade-20 margin-bottom-larger">
          {children}
        </div>
      )}
      {goBackButton && (
        <div className="flexbox flexbox-centered font-weight-bold">
          {goBackButton}
        </div>
      )}
    </div>
    <div
      className="position-absolute margin-right-large margin-bottom-large"
      style={{ bottom: 0, right: 0 }}
    >
      {metaSupportDisplay && <MetaSupport />}
    </div>
  </div>
)

export default ErrorWrapper
